import { render, staticRenderFns } from "./ProtocolEditDialog.vue?vue&type=template&id=3ff2132f&scoped=true"
import script from "./ProtocolEditDialog.vue?vue&type=script&lang=js"
export * from "./ProtocolEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProtocolEditDialog.vue?vue&type=style&index=0&id=3ff2132f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2132f",
  null
  
)

export default component.exports